import { render, staticRenderFns } from "./Limits.vue?vue&type=template&id=65867ad0&scoped=true"
import script from "./Limits.vue?vue&type=script&lang=js"
export * from "./Limits.vue?vue&type=script&lang=js"
import style0 from "./Limits.vue?vue&type=style&index=0&id=65867ad0&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65867ad0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/test-tripanels/clusterpanels/client-panel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('65867ad0')) {
      api.createRecord('65867ad0', component.options)
    } else {
      api.reload('65867ad0', component.options)
    }
    module.hot.accept("./Limits.vue?vue&type=template&id=65867ad0&scoped=true", function () {
      api.rerender('65867ad0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/alerts/Limits.vue"
export default component.exports